export default "__VITE_ASSET__ea9feea7__"